<template>
  <div class="stat-section">
    <ion-list class="mt-20 mb-2 ladder-wrapper" lines="none">
      <ion-item class="header-row">
        <ion-label class="place rank-col">
          <span class="stats-header">Rank</span>
        </ion-label>
        <ion-label class="ion-text-wrap player-name">
          <span class="stats-header">Name</span>
        </ion-label>
        <ion-label class="ion-text-wrap team-name">
          <span class="stats-header">Team</span>
        </ion-label>
        <ion-label class="stats-header stat-col">
          <span class="stats-header">Played</span>
        </ion-label>
        <ion-label class="stats-header stat-col">
          <span class="stats-header">Stat</span>
        </ion-label>
      </ion-item>
      <ion-item v-for="n in 6" :key="n">
        <ion-label class="place rank-col">
          <ion-skeleton-text animated style="width: 1.2rem; height: 0.75rem"></ion-skeleton-text>
        </ion-label>
        <ion-label class="ion-text-wrap player-name">
          <ion-skeleton-text animated style="width: 70%; height: 0.75rem"></ion-skeleton-text>
        </ion-label>
        <ion-label class="ion-text-wrap team-name">
          <span class="team-cell">
            <ion-skeleton-text animated class="avatar-shimmer"></ion-skeleton-text>
            <ion-skeleton-text animated style="width: 60%; height: 0.75rem"></ion-skeleton-text>
          </span>
        </ion-label>
        <ion-label class="stat-col">
          <ion-skeleton-text animated style="width: 1.5rem; height: 0.75rem"></ion-skeleton-text>
        </ion-label>
        <ion-label class="stat-col">
          <ion-skeleton-text animated style="width: 1.5rem; height: 0.75rem"></ion-skeleton-text>
        </ion-label>
      </ion-item>
    </ion-list>
  </div>
</template>

<script>
export default {
  name: 'LadderSkeleton',
};
</script>

<style scoped lang="scss">
.team-name {
  min-width: 10rem;
  @media only screen and(min-width: 350px) {
    min-width: 3rem;
  }
}

.player-name {
  min-width: 10rem;
  @media only screen and(min-width: 350px) {
    min-width: 7rem;
  }
}

.stat-col {
  min-width: 3rem;
  max-width: 3rem;
}

.rank-col {
  min-width: 3rem;
  max-width: 3rem;
  @media only screen and(min-width: 350px) {
    min-width: 2.5rem;
  }
}

.ladder-wrapper {
  border-radius: 1rem;
  margin-left: 1rem;
  margin-right: 1rem;
  padding-bottom: 1.5rem;
  -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
}

.stats-header {
  font-family: 'BrownStd-Regular';
  font-style: normal;
  font-weight: bold;
  font-size: .8rem;
  line-height: 1rem;
  text-align: center;
  color: white;
  text-overflow: clip;
}

.team-cell {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.avatar-shimmer {
  width: 1.25rem;
  height: 1.25rem;
  border-radius: 100%;
  flex-shrink: 0;
}

ion-list, ion-item {
  background: transparent;
  --background: transparent;
}

ion-skeleton-text {
  --background-rgb: 220, 220, 220;
}
</style>
